const light = {
  primary: '#BD9964',
  secondary: '#CC9541',
  accent: '#FF9A6B',
};

export default light;
